export default "__VITE_ASSET__70cc53e5__"